import axios from 'axios';

// Sito ecommerce → Ricerche sul sito: cosa cercano i visitatori e quante volte non trovano niente
const state = {
	items: [],
};

const getters = {
	getItems: state => state.items,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const filters = settings.filters || {};
		// la scheda Sinonimi legge le regole, le altre due le ricerche
		const res = await axios.post(
			url(context, filters.tab === 'synonyms' ? 'searchsynonyms' : 'searchlogs'),
			{
				data: {
					sortBy: sortBy[0],
					sortDesc: sortDesc[0] ? 1 : 0,
					page,
					itemsPerPage,
					search: settings.search,
					tab: filters.tab || 'zero',
					status: filters.tab === 'all' ? '' : filters.status || '',
					lang: filters.lang || '',
				},
			},
			auth(context),
		);
		context.commit('setItems', res.data.data);
		return res.data.pagination;
	},
	fetchSynonym: async (context, id) => (await axios.get(url(context, `searchsynonyms/${id}`), auth(context))).data.data,
	previewSynonym: async (context, payload) => (await axios.post(url(context, 'searchsynonyms/preview'), payload, auth(context))).data.data,
	saveSynonym: async (context, { id, form }) =>
		id ? (await axios.put(url(context, `searchsynonyms/${id}`), form, auth(context))).data.data : (await axios.post(url(context, 'searchsynonyms/create'), form, auth(context))).data.data,
	removeSynonym: async (context, id) => (await axios.delete(url(context, `searchsynonyms/${id}`), auth(context))).data.data,
	setStatus: async (context, { id, status }) => (await axios.put(url(context, `searchlogs/${id}/status`), { status }, auth(context))).data.data,
	destroyData: context => {
		context.commit('setItems', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
